import { hasText } from 'common/utils/trimHelpers';
import dayjs from 'dayjs';

export const HISTORICAL_START_DATE_CONDITION_KEY = 'historicalStartDate';
export const HISTORICAL_START_DATE_CONDITION_PARAMETER_NAME = 'startDate';
export const HISTORICAL_DAYS_BACK_CONDITION_KEY = 'historicalDaysBack';
export const HISTORICAL_DAYS_BACK_CONDITION_PARAMETER_NAME = 'daysBack';

export function isValidDateString(value: string | undefined): boolean {
    if (!value) {
        return false;
    }

    return dayjs(value).isValid();
}

export function isValidPositiveInteger(value: string | undefined): boolean {
    if (!value) {
        return false;
    }

    const numericValue = Number(value);
    return Number.isInteger(numericValue) && numericValue >= 0;
}

interface AclConditionValidator {
    parameterName: string;
    validate: (value: string | undefined) => boolean;
}

// Centralized validation registry for ACL conditions
// To add a new condition type:
// 1. Add the condition key and parameter name constants above
// 2. Add an entry here with the parameter name and validation function
// 3. Update AclConditionsDropDown.tsx CreateAclConditionValueInput switch statement to render the input
export const CONDITION_VALIDATORS: Readonly<Record<string, AclConditionValidator | undefined>> = {
    [HISTORICAL_START_DATE_CONDITION_KEY]: {
        parameterName: HISTORICAL_START_DATE_CONDITION_PARAMETER_NAME,
        validate: isValidDateString
    },
    [HISTORICAL_DAYS_BACK_CONDITION_KEY]: {
        parameterName: HISTORICAL_DAYS_BACK_CONDITION_PARAMETER_NAME,
        validate: isValidPositiveInteger
    }
};

export function isAclConditionValid(
    conditionKey: string,
    parameters: Record<string, string> | undefined
): boolean {
    if (!parameters || !Object.values(parameters).some(hasText)) {
        return false;
    }

    const validator = CONDITION_VALIDATORS[conditionKey];
    if (!validator) {
        return true;
    }

    return validator.validate(parameters[validator.parameterName]);
}
